import { BASE_URL } from '../endpoints'
import { get } from '../https'

export const getAllPolicyTracking = (
  sortBy: string,
  sortOrderValue: string
): Promise<unknown> => {
  return get(
    `${BASE_URL}/policies/agreements/users?sortBy=${sortBy}&sortOrder=${sortOrderValue}`
  )
}
